import styled, { css } from 'styled-components'
import { up } from 'styled-breakpoints'
import { pxToRem } from '../../utils'

//Styled Components for Headings: start
const headingBaseStyles = css`
  margin: 0;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.black3};
`

export const H1 = styled.h1`
  ${headingBaseStyles};
  font-size: ${pxToRem(32)};
  line-height: ${pxToRem(40)};

  ${up('md')} {
    font-size: ${pxToRem(40)};
    line-height: ${pxToRem(48)};
  }
`

export const H2 = styled.h2`
  ${headingBaseStyles};
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(36)};

  ${up('md')} {
    font-size: ${pxToRem(32)};
    line-height: ${pxToRem(40)};
  }
`

export const H3 = styled.h3`
  ${headingBaseStyles};
  font-size: ${pxToRem(24)};
  line-height: ${pxToRem(32)};

  ${up('md')} {
    font-size: ${pxToRem(28)};
    line-height: ${pxToRem(36)};
  }
`

export const H4 = styled.h4`
  ${headingBaseStyles};
  font-size: ${pxToRem(20)};
  line-height: ${pxToRem(28)};

  ${up('md')} {
    font-size: ${pxToRem(24)};
    line-height: ${pxToRem(32)};
  }
`

export const H5 = styled.h5`
  ${headingBaseStyles};
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(24)};

  ${up('md')} {
    font-size: ${pxToRem(20)};
    line-height: ${pxToRem(28)};
  }
`

export const H6 = styled.h6`
  ${headingBaseStyles};
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(24)};

  ${up('md')} {
    font-size: ${pxToRem(18)};
    line-height: ${pxToRem(24)};
  }
`
//Styled Components for Headings: End

//Styled Components for Bold : Start
export const B1 = styled.h6`
  ${headingBaseStyles};
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(20)};

  ${up('md')} {
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(24)};
  }
`

export const B2 = styled.h6`
  ${headingBaseStyles};
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(16)};

  ${up('md')} {
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
  }
`

//Styled Components for Bold : End

//Styled Components for Paragraph: Start
const paragraphBaseStyles = css`
  margin: 0;
  color: ${({ theme }) => theme.palette.grey3};
`

export const paragraph1CommonStyles = css`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(20)};

  ${up('md')} {
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(24)};
  }
`

export const P1 = styled.p`
  ${paragraphBaseStyles}
  ${paragraph1CommonStyles}
`

export const paragraph2CommonStyles = css`
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(16)};

  ${up('md')} {
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
  }
`

export const P2 = styled.p`
  ${paragraphBaseStyles}
  ${paragraph2CommonStyles}
`

export const P3 = styled.p`
  ${paragraphBaseStyles};
  font-size: ${pxToRem(10)};
  line-height: ${pxToRem(16)};

  ${up('md')} {
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
  }
`

const smallParagraphCommonStyles = css`
  font-size: ${pxToRem(9)};
  line-height: ${pxToRem(16)};
`

export const P4 = styled.p`
    ${paragraphBaseStyles}
    ${smallParagraphCommonStyles}

    ${up('md')} {
        font-size: ${pxToRem(11)};
        line-height: ${pxToRem(16)};
    }
`

export const P5 = styled.p`
    ${paragraphBaseStyles}
    ${smallParagraphCommonStyles}

    ${up('md')} {
        font-size: ${pxToRem(10)};
        line-height: ${pxToRem(16)};
    }
`

//Styled Components for Paragraph: End

export const TextLink = styled.a`
  ${paragraph1CommonStyles};
  color: ${({ theme }) => theme.colors.primary};
`

const captionBaseStyles = css`
  color: ${({ theme }) => theme.palette.grey3};
  font-style: italic;
`

export const Caption1 = styled.span`
  ${captionBaseStyles}
  ${paragraph1CommonStyles}
`

export const Caption2 = styled.span`
  ${captionBaseStyles}
  ${paragraph2CommonStyles}
`
